import type React from 'react';

import { FormField, FormHelp, Label, ToggleButton, ToggleButtonGroup } from '@zillow/constellation-10';
import { IconBuildingFilled, IconHouseFilled } from '@zillow/constellation-icons';

import type { Section } from '../../../models/index';
import { PROPERTY_TYPE } from '../../../constants/index';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
  children?: React.ReactNode;
};

function PropertyType_v1({ section, setSectionValues, children }: Props): JSX.Element {
  function onSingleFamily(_e: React.SyntheticEvent<HTMLButtonElement>): void {
    setSectionValues({
      [PROPERTY_TYPE.FIELD_NAME.TYPE_SINGLE_FAMILY]: true,
      [PROPERTY_TYPE.FIELD_NAME.TYPE_MULTI_FAMILY]: false,
    });
  }

  function onMultiFamily(_e: React.SyntheticEvent<HTMLButtonElement>): void {
    setSectionValues({
      [PROPERTY_TYPE.FIELD_NAME.TYPE_SINGLE_FAMILY]: false,
      [PROPERTY_TYPE.FIELD_NAME.TYPE_MULTI_FAMILY]: true,
    });
  }

  return (
    <>
      <FormField
        required
        css={{ marginBottom: children ? 'sm' : 0 }}
        label={<Label>What type of property is it?</Label>}
        control={
          <ToggleButtonGroup aria-label="property type">
            <ToggleButton
              selected={section.getFieldValue(PROPERTY_TYPE.FIELD_NAME.TYPE_SINGLE_FAMILY)}
              icon={<IconHouseFilled />}
              onClick={onSingleFamily}
              data-test="property-type-v1-single-family-home-btn"
            >
              Single-family home
            </ToggleButton>
            <ToggleButton
              selected={section.getFieldValue(PROPERTY_TYPE.FIELD_NAME.TYPE_MULTI_FAMILY)}
              icon={<IconBuildingFilled />}
              onClick={onMultiFamily}
              data-test="property-type-v1-multi-family-home-btn"
            >
              Multifamily home
            </ToggleButton>
          </ToggleButtonGroup>
        }
        description={
          <FormHelp>
            Apartments, condos, duplex/multiplexes, basement apartments, and in-law units are considered multifamily
            homes
          </FormHelp>
        }
      />
      {children}
    </>
  );
}

export default PropertyType_v1;
